import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { toggleShowcaseModal } from '../../../../../../slices/modals/reducer';
import { Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, TabContent, TabPane, Spinner } from "reactstrap";
import classnames from "classnames";
import FilterTab from './FilterTab';
import SecurityTab from './SecurityTab';
import EmailTab from './EmailTab';
import { createShowcase } from '../../../../../../slices/showcase/thunk';
import { toast } from 'react-toastify';

function ShowcaseModal() {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state.Modal, state => ({
    modalState: state.showcaseModal,
    showcaseModalLoader: state.showcaseModalLoader
  }));
  const { modalState, showcaseModalLoader } = useSelector(selectStates);
  const showcaseInput = useRef(null);

  const [modalTab, setModalTab] = useState("1");
  function tabToggle(tab) {
    if (modalTab !== tab) {
      setModalTab(tab);
    }
  }

  const selectShowcaseLink = createSelector(state => state.Showcase, state => state.showcaseLink);
  const showcaseLink = useSelector(selectShowcaseLink);

  function closeModal() {
    dispatch(toggleShowcaseModal())
  }

  function copyShowcaseLink() {
    const input = showcaseInput.current;
    if (input) {
      input.select(); // Metni seç
      navigator.clipboard.writeText(input.value)
      .then(() => toast.success('Copied'));
    }
  }

  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='md'>
      <ModalHeader className='p-3' toggle={closeModal}>
        <b>Public Showcase</b>
      </ModalHeader>
      <ModalBody className='px-3'>
        <p className='text-muted'>The public showcase allows you to share this banner set with team members,
          other colleagues, customers, or anyone else who needs to see your ads.
          You can select which banners and information to include in the showcase before
          sharing it. Changing the settings or filters below will adjust your showcase link.</p>
        <div className='w-100 d-flex align-items-center'>
          <input type="text" className='form-control' disabled={true} value={showcaseLink} ref={showcaseInput} />
          {showcaseLink ?
            <button className='btn btn-primary ms-1 d-flex' onClick={copyShowcaseLink}>
              Copy
              <i className='mdi mdi-content-copy align-middle ms-1'></i>
            </button>
            : null}
          <button className='btn btn-info ms-1 d-flex' disabled={showcaseModalLoader ? true : false} onClick={() => dispatch(createShowcase())}>
            Showcase
            {showcaseModalLoader ?
              <Spinner size='sm' className='ms-1'>Loading...</Spinner>
              :
              <i className='ri-share-line align-middle ms-1'></i>
            }
          </button>
        </div>
        <Nav tabs className='nav nav-tabs nav-primary nav-tabs-custom my-3'>
          <NavItem>
            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: modalTab === "1", })} onClick={() => tabToggle("1")}>
              Filter
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: modalTab === "2", })} onClick={() => tabToggle("2")}>
              Security
            </NavLink>
          </NavItem>
          {/* <NavItem>
            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: modalTab === "3", })} onClick={() => tabToggle("3")}>
              Email
            </NavLink>
          </NavItem> */}
        </Nav>
        <TabContent activeTab={modalTab}>
          <TabPane tabId="1" id='filter-tab'>
            <FilterTab />
          </TabPane>
          <TabPane tabId="2" id='security-tab'>
            <SecurityTab />
          </TabPane>
          {/* <TabPane tabId="3" id='email-tab'>
            <EmailTab />
          </TabPane> */}
        </TabContent>
      </ModalBody>
      <ModalFooter className='border-top py-3 px-3'>
        <button className='btn btn-light' onClick={closeModal}>Close</button>
      </ModalFooter>
    </Modal>
  )
}

export default ShowcaseModal
